import {
	Box,
	Button,
	Checkbox,
	Divider,
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	tableCellClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import darkBarcode from '../../assets/images/darkbarcode.png';
import lightBarcode from '../../assets/images/Bar_code_scan.png';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';

import {
	AllPartsModal,
	BasicTable,
	CurrentVsTotal,
	MarkComplete,
	ScanOrEnterBarcodeForm,
} from '../../components';
import {
	DARK_MODE,
	OPERATIONS,
	PART_VALIDATION_ERROR,
	REDIRECT_URLS,
	SCAN_ATTRIBUTE_ERROR,
  isPuneJlr
} from '../../constants';
import {
	getPartValidationDetailsForSerialNumber,
	updatePartValidation,
	validatePart,
} from '../../redux/actionCreators/partValidation';
import {
	getScanAttributeDetailsForSerialNumber,
	scannedAttributeAdd,
	updateScanAttribute,
} from '../../redux/actionCreators/scanAttribute';
import { updateReceivePart } from '../../redux/actionCreators/receivePart';
import { pxToRem, responsiveFontSizes } from '../../utils/getFontValue';
import { useRedirectToNextScreen } from '../../hooks';
import { useMessageContextManager } from '../../components/MessageOverlay/MessageOverlay';
import clsx from 'clsx';
import { ERROR_MESSAGE } from '../../constants';
import { markComplete } from '../../redux/actionCreators/printBarcode';
import SkipPart from '../../components/SkipPart/SkipPart';
import Exception from '../../components/Exception/Exception';
import TakeOut from '../../components/TakeOut/TakeOut';
import MoveToMr from '../../components/MoveToMr/MoveToMr';
import { useDispatch } from 'react-redux';
import { ReportModal } from '../../components';
import RescanModal from '../../components/ReportModal/RescanModal';
import DefectModal from '../../components/ReportModal/DefectModal';
import { getPartFamiliesToValidate } from '../../utils/utils';
import ValidPartsDetailsPopover from './ValidPartsPopover';

import StatusIcon from '../../assets/icons/StatusIcon';
import StyledTable from '../../components/StyledTable/StyledTable';
import TableActionsBar, {
	GenealogyChip,
	ProgressHeader,
} from '../../components/TableActionBar/TableActionBar';
import EclipseIcon from '../../assets/icons/EclipseIcon';
import FilledCheckIcon from '../../assets/icons/CheckIcon';
import { useTorqueColumns } from '../../components/TorqueTable/useTorqueColumns';
import ReasonAndRemarkModal from '../../components/ReportModal/ReasonAndRemarkModal';
import SkipIcon from '../../assets/icons/SkipIcon';
import { getProcessValidationDetailsForSerialNumber } from '../../redux/actionCreators/processValidation';
import { toast } from 'react-toastify';

const ROW_HEIGHT = 38;
const PV_DEFAULT_COLUMNS = [
	{
		width: 300,
		title: 'Vin',
		field: 'serialNumber',
		align: 'center'
	},
	{
		width: 240,
		title: 'KSPEC',
		field: 'parentPartNumber',
		align: 'center'
	},
	{
		width: 450,
		title: isPuneJlr() ? 'Model' : 'KSPEC Description',
		field: isPuneJlr() ? 'model' : 'description',
		align: 'center',
		render: (row) => {
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						justifyContent: 'center',
					}}
				>
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 'bold',
						}}
					>
						{isPuneJlr() ? (row.model || row.description || row.parentPartDescription) : (row.description || row.parentPartDescription)}
					</Typography>
				</Box>
			);
		},
	},
];
const INTIAL_PART_FAMILY_SCAN_DATA = {
	scannedPartNumber: '',
	isPartNumberScanningDone: false,
	isErrorInScanningPartNumber: false,
	scannedSerialNumber: '',
	isSerialNumberScanningDone: false,
	isErrorInScanningSerialNumber: false,
};

const classNames = {
	subtitles: {
		fontSize: '30px',
	},

	paper: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	tableRow: {
		verticalAlign: 'top',
	},
	tableContainer: {
		height: 3 * ROW_HEIGHT,
	},
	tableContentContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		marginTop: '10px',
		borderBottomLeftRadius: '5px',
		borderBottomRightRadius: '5px',
	},
	heading: {
		fontSize: '20px',
		fontWeight: 600,
		...responsiveFontSizes({ sm: 12, md: 20, lg: 20 }),
	},
	text: {
		display: 'flex',
		justifyContent: 'space-between',
		letterSpacing: 0.5,
		overflow: 'auto',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		fontWeight: 'normal',
		fontSize: pxToRem(16),
		...responsiveFontSizes({ sm: 16, md: 18, lg: 20 }),
	},
	enterSerialNumber: {
		color: '#3070db',
		paddingLeft: 1,
		fontWeight: 700,
		lineHeight: 1.5,
		fontSize: pxToRem(14),
		...responsiveFontSizes({ sm: 14, md: 16, lg: 24 }),
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	textInput: {
		borderRadius: 2,
		background: ({ palette }) =>
			palette.mode === DARK_MODE ? 'white' : palette.background.paper,
		paddingLeft: 2,
	},
	buttonStyles: {
		marginRight: 0,
		px: 4,
		background: '#82C1A7',
		borderRadius: 1,
		color: 'white',
		width: 70,

		'&.Mui-disabled': {
			color: 'rgba(0, 0, 0, 0.26)',
			backgroundColor: '#d8d8d8',
		},
	},
	cell: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
};

let Torque = true;

// Define your data rows
const TEST_ROWS = [
	{
		id: 1,
		name: 'DRIVEHEAD',
		number: '266835305423',
		description: 'Rubber Grommet...',
		qty: 1,
		serial: '-',
		status: 'Validated',
	},
	{
		id: 2,
		name: 'REAR AXLE',
		number: '266835000264',
		description: 'Rear axle support assembly',
		qty: 1,
		serial: '-',
		status: 'Validated',
	},
	{
		id: 3,
		name: 'FRONT AXLE',
		number: '290033000103',
		description: 'Engine mount bracket',
		qty: 1,
		serial: '-',
		status: 'Pending',
	},
	{
		id: 4,
		name: 'WHEEL RIM',
		number: '207340100132',
		description: 'Rubber Grommet...',
		qty: 1,
		serial: '-',
		status: 'Pending',
	},
	{
		id: 5,
		name: 'CHASSIS FRAME',
		number: '207341100156',
		description: 'Front frame beam',
		qty: 1,
		serial: '-',
		status: 'Validated',
	},
	{
		id: 6,
		name: 'DRIVEHEAD',
		number: '266835305423',
		description: 'Rubber Grommet...',
		qty: 1,
		serial: '-',
		status: 'Validated',
	},
	{
		id: 7,
		name: 'DRIVEHEAD',
		number: '266835305423',
		description: 'Rubber Grommet...',
		qty: 1,
		serial: '-',
		status: 'Validated',
	},
	{
		id: 8,
		name: 'DRIVEHEAD',
		number: '266835305423',
		description: 'Rubber Grommet...',
		qty: 1,
		serial: '-',
		status: 'Validated',
	},
];

const columns = [
	{
		field: 'operation',
		header: <Typography>Torque Operation</Typography>,
		minWidth: 140,
		flex: 1,
		render: (row) => (
			<Typography
				sx={{
					fontWeight: 800,
					fontSize: 22,
					color: row.status === 'success' ? '#1EBF36' : '#CB1D49',
				}}
			>
				{row.operation}
			</Typography>
		),
	},
	{
		field: 'value',
		header: <Typography>Torque Value</Typography>,
		minWidth: 120,
		flex: 1,
		render: (row) => (
			<Typography
				sx={{
					fontWeight: 800,
					fontSize: 22,
					color: row.status === 'success' ? '#1EBF36' : '#CB1D49',
				}}
			>
				{row.value}
			</Typography>
		),
	},
	{
		field: 'status',
		header: <Typography>Status</Typography>,
		minWidth: 80,
		flex: 0.4,
		render: (row) => <StatusIcon status={row.status === 'success'} />,
	},
	{
		field: 'dateTime',
		header: <Typography>Date</Typography>,
		minWidth: 120,
		flex: 1,
		render: (row) => (
			<Typography
				sx={{
					fontWeight: 800,
					fontSize: 20,
					color: row.status === 'success' ? '#1EBF36' : '#CB1D49',
				}}
			>
				{row.dateTime}
			</Typography>
		),
	},
];

const data = [
	{
		operation: 'Bolt Tightening',
		value: '56 Nm',
		status: 'success',
		dateTime: '09/05/2025 11:02:25',
	},
	{
		operation: 'Leak / Pressure Test',
		value: 'Pressure applied',
		status: 'error',
		dateTime: '09/05/2025 11:02:25',
	},
	{
		operation: 'Bolt Tightening',
		value: '56 Nm',
		status: 'success',
		dateTime: '09/05/2025 11:02:25',
	},
];
const mapStateToProps = (state) => {
	return {
		receivePart: state.receivePart,
		partValidation: state.partValidation,
		processValidation: state.processValidation,
		themeMode: state.theme.themeMode,
		isMobileStation: state.user.isMobileStation,
		currentLineItem: state.station.currentLineItem,
		modeType: state.modeType,
		operations: state.operations.allowedOperations,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getPartValidationDetailsForSerialNumber: (
		successCallback,
		errorCallback,
		sequenceNumber,
	) =>
		dispatch(
			getPartValidationDetailsForSerialNumber(
				successCallback,
				errorCallback,
				sequenceNumber,
			),
		),
	getScanAttributeDetailsForSerialNumber: (
		successCallback,
		errorCallback,
		serialNumber,
	) =>
		dispatch(
			getScanAttributeDetailsForSerialNumber(
				successCallback,
				errorCallback,
				serialNumber,
			),
		),
	scannedAttributeAdd: (asn, payload, successCallback, errorCallback) =>
		dispatch(
			scannedAttributeAdd(asn, payload, successCallback, errorCallback),
		),
	updateScanAttribute: (data) => dispatch(updateScanAttribute(data)),
	validatePart: (sequenceNumber, payload, successCallback, errorCallback) =>
		dispatch(
			validatePart(sequenceNumber, payload, successCallback, errorCallback),
		),
	updatePartValidation: (data) => dispatch(updatePartValidation(data)),
	updateReceivePart: (data) => dispatch(updateReceivePart(data)),
	markComplete: (successCallback, errorCallback, sequenceNumber) =>
		dispatch(markComplete(successCallback, errorCallback, sequenceNumber)),
});

// SCAN_ATTRIBUTE: table columns for part-attribute flow (attributeId, attributeName, scannedValue when scanned)
const SCAN_ATTRIBUTE_COLUMNS = [
	{
		title: 'Attribute ID',
		field: 'attributeId',
		label: 'Attribute ID',
		width: 140,
		sortable: true,
		align: 'center',

	},
	{
		title: 'Attribute Name',
		field: 'attributeName',
		label: 'Attribute Name',
		width: 260,
		sortable: true,
		align: 'center',

	},
	{
		title: 'Scanned Value',
		field: 'scannedValue',
		label: 'Scanned Value',
		width: 160,
		sortable: true,
		align: 'center',

		render: (row) => (
			<Typography component="span" sx={{ fontSize: pxToRem(15), ...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }) }}>
				{row.validatedAt || (row.scannedValue != null && row.scannedValue !== '') ? (row.scannedValue ?? '-') : '-'}
			</Typography>
		),
	},
];

const PVnG_DEFAULT_COLUMNS = [
	{
		width: 250,
		title: 'Part Family',
		field: 'familyName',
	},
	{
		width: 250,
		title: 'Part Number',
		field: 'partNumber',
		render: (
			prop,
			{
				openEllipsisPopupForEventWithText: handlePopoverOpen,
				closeEllipsisPopup: handlePopoverClose,
				onCopy,
			},
		) => {
			return (
				<Box sx={{ display: 'flex' }}>
					<Typography
						sx={{
							whiteSpace: 'nowrap',
							width: '90%',
							textAlign: 'left',
							letterSpacing: 0.5,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							fontSize: pxToRem(15),
							...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
							opacity: !prop.hasOwnProperty('isErrorInScanningPartFamily')
								? 0.8
								: 1,
							color: !prop.hasOwnProperty('isErrorInScanningPartFamily')
								? null
								: prop.isErrorInScanningPartFamily
									? '#F17C7C'
									: '#82C1A7',
						}}
						onMouseEnter={(e) => handlePopoverOpen(e, prop.partNumber)}
						onMouseLeave={() => handlePopoverClose()}
						onDoubleClick={() => onCopy(prop.partNumber)}
					>
						{prop.partNumber}
					</Typography>
					<ValidPartsDetailsPopover rowData={prop?.validParts} />
				</Box>
			);
		},
	},
	{
		width: 300,
		title: 'Part Description',
		field: 'partDescription',
		render: (
			prop,
			{
				openEllipsisPopupForEventWithText: handlePopoverOpen,
				closeEllipsisPopup: handlePopoverClose,
				onCopy,
			},
		) => {
			return (
				<Typography
					sx={{
						letterSpacing: 0.5,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						fontSize: pxToRem(15),
						...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
						opacity: !prop.hasOwnProperty('isErrorInScanningPartFamily')
							? 0.8
							: 1,
						color: !prop.hasOwnProperty('isErrorInScanningPartFamily')
							? null
							: prop.isErrorInScanningPartFamily
								? '#F17C7C'
								: '#82C1A7',
					}}
					onMouseEnter={(e) => handlePopoverOpen(e, prop.partDescription)}
					onMouseLeave={() => handlePopoverClose()}
					onDoubleClick={() => onCopy(prop.partDescription)}
				>
					{prop.partDescription}
				</Typography>
			);
		},
	},
	{
		width: 150,
		title: 'Quantity',
		field: 'quantity',
		render: (prop) => {
			return (
				<CurrentVsTotal
					classNames={{
						currentNumber: {
							fontWeight: 700,
							fontSize: pxToRem(16),
							...responsiveFontSizes({ sm: 16, md: 18, lg: 24 }),
						},
						totalNumber: {
							fontSize: pxToRem(13),
							...responsiveFontSizes({ sm: 13, md: 15, lg: 19 }),
						},
					}}
					currentNumber={prop.partPosition}
					totalNumber={prop.quantity}
				/>
			);
		},
	},
	{
		width: 250,
		title: 'Serial Number',
		field: 'displaySerialNumber',
		render: (
			prop,
			{
				openEllipsisPopupForEventWithText: handlePopoverOpen,
				closeEllipsisPopup: handlePopoverClose,
				onCopy,
			},
		) => {
			return (
				<Typography
					sx={{
						letterSpacing: 0.5,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						fontSize: pxToRem(15),
						...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
						opacity:
							!prop.skipReason &&
								(prop.displaySerialNumber || prop.scannedSerialNumber)
								? 0.8
								: 1,
						color:
							!prop.hasOwnProperty('isErrorInScanningPartFamily') &&
								!prop.skipReason &&
								(prop.displaySerialNumber || prop.scannedSerialNumber)
								? '#82C1A7'
								: '#F17C7C',
					}}
					onMouseEnter={(e) =>
						handlePopoverOpen(
							e,
							prop.displaySerialNumber || prop.scannedSerialNumber,
						)
					}
					onMouseLeave={() => handlePopoverClose()}
					onDoubleClick={() =>
						onCopy(prop.displaySerialNumber || prop.scannedSerialNumber)
					}
				>
					{prop.displaySerialNumber || prop.scannedSerialNumber || '-'}
				</Typography>
			);
		},
	},
	{
		width: 250,
		title: 'Part Validation & Genealogy',
		field: 'partValidation&Genealogy',
		render: ({
			isSelected,
			skipReason,
			scannedSerialNumber,
			scannedPartNumber,
		}) => (
			<Grid item display="flex">
				{(scannedSerialNumber || scannedPartNumber) && !skipReason ? (
					<CheckIcon sx={{ color: '#82C1A7' }} />
				) : (
					<ReportProblemRoundedIcon color="error" />
				)}
				<Typography
					component="span"
					sx={{
						paddingLeft: 1,
						letterSpacing: 0.5,
						fontWeight: isSelected ? 700 : 500,
						fontSize: pxToRem(15),
						...responsiveFontSizes({ sm: 15, md: 17, lg: 21 }),
						color:
							(scannedSerialNumber || scannedPartNumber) && !skipReason
								? '#82C1A7'
								: '#e47778',
					}}
				>
					{(scannedSerialNumber || scannedPartNumber) && !skipReason
						? 'Validated'
						: skipReason
							? 'Skipped'
							: 'Pending'}
				</Typography>
			</Grid>
		),
	},
	{
		width: 250,
		title: 'Reason to Skip',
		field: 'skipReason',
		columnStyle: {
			color: '#F17C7C',
		},
	},
];

const UpdatePartValidationGenealogy = ({
	partValidation,
	processValidation,
	selectedRows,
	themeMode,
	tableRows,
	setTableRows,
	revalidatePart,
	validatePart,
	setAllScanned,
}) => {
	const { isPopupOpen, showMessageOverlay } = useMessageContextManager();
	const [partFamilyScannedData, setPartFamilyScannedData] = useState(
		INTIAL_PART_FAMILY_SCAN_DATA,
	);
	const [skippedSerialNumber, setSkippedSerialNumber] = useState('');
	const [skippedPartNumber, setSkippedPartNumber] = useState('');
	const [successMessage, setSuccessMessage] = useState('');

	const { scanJobDetails } = partValidation;

	const partNumberInputRef = useRef(null);
	const serialNumberInputRef = useRef(null);

	const onPartNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const {
			validParts,
			sequenceNumber,
			familyId,
			partNumber,
			scanJobResultId,
			skipReason,
			partNumberScanningRequired,
			genealogyRequired,
			partPosition,
			scannedPartNumber,
		} = selectedRows[0];

		const successCallback = (updatedPartFamilyScannedData = {}) => {
			closeMesssageOverlay();
			setSuccessMessage('Part Matched');
			setPartFamilyScannedData({
				...partFamilyScannedData,
				scannedPartNumber: scannedValue,
				isPartNumberScanningDone: true,
				isErrorInScanningPartNumber: false,
				...updatedPartFamilyScannedData,
			});
			setTimeout(() => {
				setSuccessMessage('');
				resetBarcodeValue();
			}, 3000);
		};

		const errorCallback = () => {
			const rowsData = tableRows.map((partFamily) => {
				if (
					partFamily.familyId === familyId &&
					partFamily.partPosition === partPosition
				)
					return {
						...partFamily,
						scannedValue,
						skippedPartNumber: scannedValue,
						isErrorInScanningPartFamily: true,
					};
				return { ...partFamily };
			});
			setTableRows(rowsData);
			closeMesssageOverlay();
			setSkippedPartNumber(scannedValue);
			setPartFamilyScannedData((prev) => ({
				...prev,
				isPartNumberScanningDone: false,
				isErrorInScanningPartNumber: true,
			}));
			resetBarcodeValue();
			showMessageOverlay({
				contextText:
					PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Part Number',
				info: 'Part did not match',
				error: true,
			});
		};

		const onlyPartNoScanningSuccessCallback = () => {
			successCallback({ ...INTIAL_PART_FAMILY_SCAN_DATA });
		};

		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Part Number.',
			loading: true,
		});

		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedPartNumber: scannedValue,
		}));

		const payload = {
			familyId,
			partNumber,
			scannedPartNumber: scannedValue,
			scannedSerialNumber: '',
		};

		if (!genealogyRequired && partNumberScanningRequired) {
			if (skipReason || scannedPartNumber) {
				revalidatePart(
					sequenceNumber,
					scanJobResultId,
					{ ...payload },
					() => {
						onlyPartNoScanningSuccessCallback();
						tableRows.filter((item) => {
							if (item?.quantity === item?.scanJobResults?.length) {
								return setAllScanned(true);
							} else {
								return setAllScanned(false);
							}
						});
					},
					(error) => {
						errorCallback();
					},
				);
			} else {
				validatePart(
					sequenceNumber,
					{ ...payload },
					() => {
						onlyPartNoScanningSuccessCallback();
						tableRows.filter((item) => {
							if (item?.quantity === item?.scanJobResults?.length) {
								return setAllScanned(true);
							} else {
								return setAllScanned(false);
							}
						});
					},
					(error) => {
						errorCallback();
					},
				);
			}
		}
		if (genealogyRequired && partNumberScanningRequired) {
			if (validParts.includes(scannedValue)) {
				successCallback();
			} else {
				errorCallback();
			}
		}
	};

	const onSerialNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const {
			sequenceNumber,
			familyId,
			partNumber,
			scanJobResultId,
			skipReason,
			partNumberScanningRequired,
			genealogyRequired,
			partPosition,
			scannedSerialNumber,
		} = selectedRows[0];

		const successCallback = () => {
			closeMesssageOverlay();
			setSuccessMessage('Serial Number Matched');
			setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
			setTimeout(() => {
				setSuccessMessage('');
				resetBarcodeValue();
			}, 3000);
		};

		const errorCallback = (error) => {
			const rowsData = tableRows.map((partFamily) => {
				if (
					partFamily.familyId === familyId &&
					partFamily.partPosition === partPosition
				)
					return {
						...partFamily,
						scannedValue,
						skippedSerialNumber: scannedValue,
						displaySerialNumber: scannedValue,
						isErrorInScanningPartFamily: true,
					};
				return { ...partFamily };
			});
			setTableRows(rowsData);
			setSkippedSerialNumber(scannedValue);
			closeMesssageOverlay();
			setPartFamilyScannedData((prev) => ({
				...prev,
				isSerialNumberScanningDone: false,
				isErrorInScanningSerialNumber: true,
			}));
			resetBarcodeValue();
			showMessageOverlay({
				contextText:
					PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Serial Number',
				info: error.response.data.message,
				error: true,
			});
		};

		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Serial Number.',
			loading: true,
		});

		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedSerialNumber: scannedValue,
		}));

		const payload = {
			familyId,
			partNumber,
			scannedPartNumber:
				genealogyRequired && !partNumberScanningRequired
					? ''
					: partFamilyScannedData.scannedPartNumber,
			scannedSerialNumber: scannedValue,
		};

		if (skipReason || scannedSerialNumber) {
			revalidatePart(
				sequenceNumber,
				scanJobResultId,
				{ ...payload },
				() => {
					successCallback();
					tableRows.filter((item) => {
						if (item?.quantity === item?.scanJobResults?.length) {
							return setAllScanned(true);
						} else {
							return setAllScanned(false);
						}
					});
				},
				(error) => {
					errorCallback(error);
				},
			);
		} else {
			validatePart(
				sequenceNumber,
				{ ...payload },
				() => {
					successCallback();
					tableRows.filter((item) => {
						if (item?.quantity === item?.scanJobResults?.length) {
							return setAllScanned(true);
						} else {
							return setAllScanned(false);
						}
					});
				},
				(error) => {
					errorCallback(error);
				},
			);
		}
	};

	useEffect(() => {
		if (partValidation?.sequenceNumber) {
			const rowsData = getPartFamiliesToValidate(
				partValidation?.scanJobDetails,
				partValidation?.sequenceNumber,
			);

			setTableRows(rowsData);
		}
	}, [partValidation]);

	const isSkipDisabled = () => {
		const selectedRow = selectedRows[0];
		const latestPartToSkip = tableRows.find(
			(row) =>
				row.familyId === selectedRow.familyId &&
				!(row.scannedPartNumber || row.scannedSerialNumber || row.skipReason),
		);
		if (selectedRow.partPosition === latestPartToSkip.partPosition)
			return false;
		return true;
	};

	const partSkipSuccessCallback = (data, closeSkipSerialNumberDialog) => {
		const { scanJobDetails, sequenceNumber } = data;
		const rowsData = getPartFamiliesToValidate(scanJobDetails, sequenceNumber);
		setTableRows(rowsData);
		closeSkipSerialNumberDialog();
		// setSuccessMessage('Part Skipped');
		toast.success('Part Skipped');

		setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
		// setTimeout(() => {
		//     setSuccessMessage('');
		// }, 3000);
	};

	const partSkipErrorCallback = (error, closeSkipSerialNumberDialog) => {
		closeSkipSerialNumberDialog();
		showMessageOverlay({
			contextText:
				PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Skipping Part Family',
			info: error.response.data.message,
			error: true,
		});
	};

	const renderInputFields = () => {
		const {
			partNumberScanningRequired,
			genealogyRequired,
			isErrorInScanningPartFamily,
		} = selectedRows[0];

		if (
			partNumberScanningRequired &&
			!partFamilyScannedData.isPartNumberScanningDone
		)
			return (
				<Grid
					item
					container
					direction="column"
					alignItems="end"
					columnSpacing={2}
					sx={{ opacity: selectedRows.length == 1 ? '100%' : '50%' }}
				>
					<Grid item display="flex" alignItems="center">
						{isErrorInScanningPartFamily &&
							partFamilyScannedData.isErrorInScanningPartNumber ? (
							<Typography variant="h3" color="error">
								RESCAN PART NO.
							</Typography>
						) : (
							<Typography variant="h3" sx={{ color: '#27C8F7' }}>
								SCAN PART NO.
							</Typography>
						)}
						<Box
							item
							sx={{
								height: { xs: 35, md: 40, lg: 60 },
								width: { xs: 75, md: 85, lg: 130 },
							}}
						>
							<img
								src={themeMode === DARK_MODE ? darkBarcode : lightBarcode}
								alt=""
								style={{
									height: '100%',
									width: '100%',
									objectFit: 'cover',
								}}
							/>
						</Box>
					</Grid>
					<Grid item xs={12} sx={{ width: { sm: '75%', md: '60%' } }} pt={1}>
						<ScanOrEnterBarcodeForm
							enableAutoEnter={
								genealogyRequired && partNumberScanningRequired ? false : true
							}
							inputRef={partNumberInputRef}
							inputProps={{
								disabled: selectedRows.length !== 1,
							}}
							onSubmit={onPartNumberSubmit}
						/>
					</Grid>
				</Grid>
			);
		if (genealogyRequired && !partFamilyScannedData.isSerialNumberScanningDone)
			return (
				<Grid
					item
					container
					direction="column"
					alignItems="end"
					columnSpacing={2}
					sx={{ opacity: selectedRows.length == 1 ? '100%' : '50%' }}
				>
					<Grid item display="flex" alignItems="center">
						{isErrorInScanningPartFamily &&
							partFamilyScannedData.isErrorInScanningSerialNumber ? (
							<Typography variant="h3" color="error">
								RESCAN SERIAL NUMBER
							</Typography>
						) : (
							<Typography variant="h3" sx={{ color: '#27C8F7' }}>
								SCAN SERIAL NUMBER
							</Typography>
						)}
						<Box
							item
							sx={{
								height: { xs: 35, md: 40, lg: 60 },
								width: { xs: 75, md: 85, lg: 130 },
							}}
						>
							<img
								src={themeMode === DARK_MODE ? darkBarcode : lightBarcode}
								alt=""
								style={{
									height: '100%',
									width: '100%',
									objectFit: 'cover',
								}}
							/>
						</Box>
					</Grid>
					<Grid item xs={12} sx={{ width: { sm: '75%', md: '60%' } }} pt={1}>
						<ScanOrEnterBarcodeForm
							enableAutoEnter={
								genealogyRequired && partNumberScanningRequired ? false : true
							}
							inputRef={serialNumberInputRef}
							inputProps={{
								disabled: selectedRows.length !== 1,
							}}
							onSubmit={onSerialNumberSubmit}
						/>
					</Grid>
				</Grid>
			);
	};

	useEffect(() => {
		if (!isPopupOpen) {
			if (partNumberInputRef.current) partNumberInputRef.current.focus();
			if (serialNumberInputRef.current) serialNumberInputRef.current.focus();
		}
	}, [selectedRows, isPopupOpen]);

	return (
		<>
			<Grid item xs={5} display="flex" flexWrap="wrap" alignItems="flex-end">
				<Grid item pt={1}>
					{!successMessage &&
						selectedRows.length === 1 &&
						!(
							selectedRows[0]?.skipReason ||
							selectedRows[0]?.scannedSerialNumber ||
							selectedRows[0]?.scannedPartNumber
						) && (
							<SkipPart
								skippedPartNumber={selectedRows[0].skippedPartNumber}
								skippedSerialNumber={selectedRows[0].skippedSerialNumber}
								disableBtn={isSkipDisabled()}
								hoverMessage="Please select the quantity in sequential manner"
								successCallback={partSkipSuccessCallback}
								errorCallback={partSkipErrorCallback}
								currentPartNumber={scanJobDetails.findIndex(
									(part) => part.familyId === selectedRows[0]?.familyId,
								)}
							/>
						)}
				</Grid>
				{successMessage && (
					<>
						<CheckIcon
							color="primary"
							sx={{
								fontSize: {
									lg: 34,
								},
							}}
						/>
						<Typography
							variant="h4"
							component="span"
							color="primary"
							fontWeight={400}
							paddingLeft={1}
						>
							{successMessage}
						</Typography>
					</>
				)}
			</Grid>
			<Grid item xs={7}>
				{!successMessage && !!selectedRows.length && renderInputFields()}

			</Grid>
		</>
	);
};

export const ProcessValidationStages = ({
	receivePart,
	partValidation,
	processValidation,
	themeMode,
	// getProcesstValidationDetailsForSerialNumber,
	getPartValidationDetailsForSerialNumber,
	getScanAttributeDetailsForSerialNumber,
	scannedAttributeAdd,
	updateScanAttribute,
	validatePart,
	updatePartValidation,
	updateReceivePart,
	markComplete,
	isMobileStation,
	currentLineItem,
	modeType,
	operations
}) => {
	const { handleNext } = useOutletContext();
	const [allSacnned, setAllScanned] = useState(false);
	const redirect = useRedirectToNextScreen();
	const inputRef = useRef(null);
	const [currentPartNumber, setCurrentPartNumber] = useState(null);
	const [TEXT_ROWS, setTextRows] = useState([
		{
			id: 1,
			name: 'DRIVEHEAD',
			number: '266835305423',
			description: 'Rubber Grommet...',
			qty: 1,
			serial: '-',
			status: 'Validated',
		},
		{
			id: 2,
			name: 'REAR AXLE',
			number: '266835000264',
			description: 'Rear axle support assembly',
			qty: 1,
			serial: '-',
			status: 'Validated',
		},
		{
			id: 3,
			name: 'FRONT AXLE',
			number: '290033000103',
			description: 'Engine mount bracket',
			qty: 1,
			serial: '-',
			status: 'Pending',
		},
		{
			id: 4,
			name: 'WHEEL RIM',
			number: '207340100132',
			description: 'Rubber Grommet...',
			qty: 1,
			serial: '-',
			status: 'Pending',
		},
		{
			id: 5,
			name: 'CHASSIS FRAME',
			number: '207341100156',
			description: 'Front frame beam',
			qty: 1,
			serial: '-',
			status: 'Validated',
		},
		{
			id: 6,
			name: 'CHASSIS FRAME',
			number: '207341100156',
			description: 'Front frame beam',
			qty: 1,
			serial: '-',
			status: 'Validated',
		},
		{
			id: 7,
			name: 'CHASSIS FRAME',
			number: '207341100156',
			description: 'Front frame beam',
			qty: 1,
			serial: '-',
			status: 'Validated',
		},
	]);

	const [TEXT_COLUMNS, setTextColumns] = useState([
		{
			title: 'Part Name',
			field: 'familyName',
			label: 'Part Name',
			width: 160, // ↓ reduced
			sortable: true,
		},
		{
			title: 'Part Number',
			field: 'partNumber',
			label: 'Part Number',
			width: 120, // ↓ reduced significantly
			sortable: true,
		},
		{
			title: 'Status',
			field: 'partDescription',
			label: 'Status',
			width: 180, // ↓ reduced for tighter layout
			sortable: true,
		},
		{
			title: 'Qty',
			field: 'quantity',
			label: 'Qty',
			width: 60,
			render: (row) => (
				<Typography
					sx={{
						fontFamily: "'Uni Neue', sans-serif",
						fontWeight: 800,
						fontSize: '20px',
						textAlign: 'center',
					}}
				>
					{row.quantity}
				</Typography>
			),
			sortable: true,
		},
		{
			title: 'Serial Number',
			field: 'scannedSerialNumber',
			label: 'Serial Number',
			width: 140,
			render: (row) => (
				<Typography
					sx={{
						fontFamily: "'Uni Neue', sans-serif",
						fontWeight: 800,
						fontSize: '20px',
						textAlign: 'center',
					}}
				>
					{row.scannedSerialNumber ?? '-'}
				</Typography>
			),

			sortable: true,
		},
		{
			title: 'Status',
			field: 'status',
			label: 'Status',
			width: 100,
			render: (row, theme) => {
				const isDark = theme.palette.mode === 'dark';
				const isNull =
					row.scannedSerialNumber === null ||
					row.scannedSerialNumber === 'null';

				const color = isNull
					? '#1B681B' // green skip icon when null
					: isDark
						? '#FFFFFF'
						: '#202020';

				return (
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						{isNull ? (
							<SkipIcon style={{ color, width: 28, height: 28 }} />
						) : row.status === 'validated' ? (
							<FilledCheckIcon style={{ color, width: 28, height: 28 }} />
						) : (
							<SkipIcon style={{ color, width: 28, height: 28 }} />
						)}
					</Box>
				);
			},
		},
	]);
	const dispatch = useDispatch();
	const [rows, setRows] = useState([]);

	const columns = useTorqueColumns();
	useEffect(() => {
		if (!partValidation.sequenceNumber) return;

		const isScanAttributeOnly = operations?.includes('SCAN_ATTRIBUTE') &&
			!operations?.includes('PART_VALIDATION');
		if (isScanAttributeOnly) return; // 

		dispatch(
			getProcessValidationDetailsForSerialNumber(
				partValidation.sequenceNumber,
				(data) => {
					setRows(data);
				},
				(err) => {
					console.error('Failed to fetch data:', err);
				},
			),
		);
	}, [partValidation.sequenceNumber, operations, dispatch]);

	const data = [
		{
			operation: 'Bolt Tightening',
			value: '56 Nm',
			status: 'success',
			dateTime: '09/05/2025 11:02:25',
		},
		{
			operation: 'Leak / Pressure Test',
			value: 'Pressure applied',
			status: 'error',
			dateTime: '09/05/2025 11:02:25',
		},
		{
			operation: 'Bolt Tightening',
			value: '56 Nm',
			status: 'success',
			dateTime: '09/05/2025 11:02:25',
		},
	];

	const [selectedPvRows, setSelectedPvRows] = useState([]);

	const handleSelectionChange = (selectedIds) => {
		setSelectedPvRows(selectedIds);
	};

	// SCAN_ATTRIBUTE: part-attribute API data { asn, serialNumber, attributes } (declared before pvData which uses it)
	const [attributeData, setAttributeData] = useState(null);
	const [selectedAttributeRowId, setSelectedAttributeRowId] = useState(null);
	const [attributeScanSuccessMessage, setAttributeScanSuccessMessage] = useState('');
	const [noAttributeConfigured, setNoAttributeConfigured] = useState(false);

	const pvData = [
  {
    serialNumber:
      attributeData?.serialNumber ||
      partValidation?.serialNumber ||
      currentLineItem?.serialNumber ||
      receivePart?.serialNumber,
    parentPartNumber:
      partValidation?.parentPartNumber ||
      partValidation?.partNumber ||
      currentLineItem?.partNumber,
    parentPartDescription:
      partValidation?.parentPartDescription ||
      partValidation?.description ||
      currentLineItem?.description,
    model:
      currentLineItem?.model ||
      partValidation?.model,
    description:
      partValidation?.parentPartDescription ||
      partValidation?.description ||
      currentLineItem?.description,
  },
];
	const { scanJobDetails = [] } = partValidation;

	const [displayedRows, setDisplayedRows] = useState(scanJobDetails || []);

	const {
		familyId,
		familyName,
		partNumber,
		partDescription,
		quantity,
		scanJobResults = [],
		validParts,
		genealogyRequired,
		partNumberScanningRequired,
	} = scanJobDetails[currentPartNumber] || {};

	const [isDetailsModalOpen, setIsDetailModalOpen] = useState(false);
	const [isReportModalOpen, setIsReportModalOpen] = useState(false);
	const [isDefectModalOpen, setIsDefectModalOpen] = useState(false);

	const [partFamilyScannedData, setPartFamilyScannedData] = useState(
		INTIAL_PART_FAMILY_SCAN_DATA,
	);
	const [skippedSerialNumber, setSkippedSerialNumber] = useState('');
	const [skippedPartNumber, setSkippedPartNumber] = useState('');
	const [successMessage, setSuccessMessage] = useState('');

	const [tableRows, setTableRows] = useState(null);

	const [noPartFamilyConfigured, setNoPartFamilyConfigured] = useState(false);
	const [selectedRows1, setSelectedRows1] = useState([]);
	const [skippart, setSkippart] = useState(null);

	const handleSelect = (index) => {
		setSelectedRows1((prevSelected) => {
			if (prevSelected.includes(index)) {
				return prevSelected.filter((i) => i !== index);
			} else {
				return [...prevSelected, index];
			}
		});
	};

	const getskipRow = (row) => {
		setSkippart(row);
	};

	const { isPopupOpen, showMessageOverlay } = useMessageContextManager();

	const openDetailsModal = () => setIsDetailModalOpen(true);
	const closeDetailsModal = () => {
		if (inputRef.current) inputRef.current.focus();
		setIsDetailModalOpen(false);
	};

	const openReportModal = () => setIsReportModalOpen(true);
	const closeReportModal = () => setIsReportModalOpen(false);

	const [isTakeOutModalOpen, setIsTakeOutModalOpen] = useState(false);
	const openTakeOutModal = () => setIsTakeOutModalOpen(true);
	const closeTakeOutModal = () => setIsTakeOutModalOpen(false);

	const redirectToNextScreen = (scanJobDetails) => {
		const nonScannedPartFamilyIndex = scanJobDetails.findIndex(
			(scanJob) => scanJob.scanJobResults.length !== scanJob.quantity,
		);

		if (nonScannedPartFamilyIndex === -1)
			setCurrentPartNumber(scanJobDetails.length - 1);
		else setCurrentPartNumber(nonScannedPartFamilyIndex);
	};

	const onPartNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Part Number.',
			loading: true,
		});

		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedPartNumber: scannedValue,
		}));

		if (!genealogyRequired && partNumberScanningRequired)
			validatePart(
				partValidation.sequenceNumber,
				{
					familyId,
					partNumber,
					scannedPartNumber: scannedValue,
					scannedSerialNumber: '',
				},
				(data) => {
					const { scanJobDetails } = data;
					closeMesssageOverlay();
					setSuccessMessage('Part Matched');
					setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
					setTimeout(() => {
						setSuccessMessage('');
						resetBarcodeValue();
						redirectToNextScreen(scanJobDetails);
					}, 3000);
				},
				(error) => {
					// logError(`Part number validation ${error}`);
					closeMesssageOverlay();
					setSkippedPartNumber(scannedValue);
					setPartFamilyScannedData((prev) => ({
						...prev,
						isPartNumberScanningDone: false,
						isErrorInScanningPartNumber: true,
					}));
					showMessageOverlay({
						contextText:
							PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Part Number',
						info: error.response.data.message,
						error: true,
					});
					resetBarcodeValue();
				},
			);
		if (genealogyRequired && partNumberScanningRequired) {
			if (validParts.includes(scannedValue)) {
				closeMesssageOverlay();
				setSuccessMessage('Part Matched');
				setPartFamilyScannedData({
					...partFamilyScannedData,
					scannedPartNumber: scannedValue,
					isPartNumberScanningDone: true,
					isErrorInScanningPartNumber: false,
				});
				setTimeout(() => {
					setSuccessMessage('');
					resetBarcodeValue();
				}, 3000);
			} else {
				// logError('Part did not match');
				closeMesssageOverlay();
				setPartFamilyScannedData((prev) => ({
					...prev,
					isPartNumberScanningDone: false,
					isErrorInScanningPartNumber: true,
				}));
				showMessageOverlay({
					contextText:
						PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Part Number',
					info: 'Part did not match ',
					error: true,
				});
				resetBarcodeValue();
			}
		}
	};

	const onSerialNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const closeMesssageOverlay = showMessageOverlay({
			contextText: 'Scanning Serial Number.',
			loading: true,
		});

		setPartFamilyScannedData((prev) => ({
			...prev,
			scannedSerialNumber: scannedValue,
		}));

		validatePart(
			partValidation.sequenceNumber,
			{
				familyId,
				partNumber,
				scannedPartNumber:
					genealogyRequired && !partNumberScanningRequired
						? ''
						: partFamilyScannedData.scannedPartNumber,
				scannedSerialNumber: scannedValue,
			},
			(data) => {
				const { scanJobDetails } = data;
				closeMesssageOverlay();
				setSuccessMessage('Serial Number Matched');
				setSkippedSerialNumber('');
				setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
				setTimeout(() => {
					setSuccessMessage('');
					resetBarcodeValue();
					redirectToNextScreen(scanJobDetails);
				}, 3000);
			},
			(error) => {
				// logError(`Serial number validation ${error}`);
				closeMesssageOverlay();
				setSkippedSerialNumber(scannedValue);
				setPartFamilyScannedData((prev) => ({
					...prev,
					isSerialNumberScanningDone: false,
					isErrorInScanningSerialNumber: true,
				}));
				showMessageOverlay({
					contextText:
						PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Scanning Serial Number',
					info: error?.response?.data?.message,
					error: true,
				});
				resetBarcodeValue();
			},
		);
	};

	const partSkipSuccessCallback = (data, closeSkipSerialNumberDialog) => {
		const { scanJobDetails } = data;
		closeSkipSerialNumberDialog();
		// setSuccessMessage('Part Skipped');
		toast.success('Part Skipped');

		setPartFamilyScannedData(INTIAL_PART_FAMILY_SCAN_DATA);
		// setTimeout(() => {
		//     setSkippedSerialNumber('');
		//     setSuccessMessage('');
		//     redirectToNextScreen(scanJobDetails);
		// }, 3000);
	};

	const partSkipErrorCallback = (error, closeSkipSerialNumberDialog) => {
		// logError(`Skip Part Family ${error}`);
		closeSkipSerialNumberDialog();
		setSkippedSerialNumber(partFamilyScannedData.scannedSerialNumber);
		showMessageOverlay({
			contextText:
				PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Skipping Part Family',
			info: error.response.data.message,
			error: true,
		});
	};

	const renderInputFields = () => {
		if (
			partNumberScanningRequired &&
			!partFamilyScannedData.isPartNumberScanningDone
		)
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center', // vertically center image and input
						gap: '-2px', // small space between barcode and input
						width: '100%',
						padding: 0,
						margin: 0,
					}}
				>
					{/* Barcode Image */}
					<Box
						sx={{
							height: { xs: 35, md: 40, lg: 80 },
							width: { xs: 75, md: 85, lg: 130 },
							flexShrink: 0, // prevent image from shrinking
						}}
					>
						<img
							src={darkBarcode}
							alt="barcode"
							style={{
								height: '100%',
								width: '100%',
								objectFit: 'contain',
								display: 'block',
							}}
						/>
					</Box>

					{/* Input Form */}
					<Box sx={{ flexGrow: 1 }}>
						<ScanOrEnterBarcodeForm
							enableAutoEnter={
								genealogyRequired && partNumberScanningRequired ? false : true
							}
							inputRef={inputRef}
							onSubmit={onPartNumberSubmit}
						/>
					</Box>
				</Box>
			);
		if (genealogyRequired && !partFamilyScannedData.isSerialNumberScanningDone)
			return (
				<Grid
					item
					container
					direction="column"
					alignItems="end"
					columnSpacing={2}
					xs={7}
				>
					<Grid item display="flex" alignItems="center">
						{!partFamilyScannedData.isErrorInScanningSerialNumber ? (
							<Typography variant="h3" sx={{ color: '#27C8F7' }}>
								SCAN SERIAL NUMBER
							</Typography>
						) : (
							<Typography variant="h3" color="error">
								RESCAN SERIAL NUMBER
							</Typography>
						)}

						<Box
							item
							sx={{
								height: { xs: 35, md: 40, lg: 60 },
								width: { xs: 75, md: 85, lg: 130 },
							}}
						>
							<img
								src={themeMode === DARK_MODE ? darkBarcode : lightBarcode}
								alt=""
								style={{
									height: '100%',
									width: '100%',
									objectFit: 'cover',
								}}
							/>
						</Box>
					</Grid>

					<Grid item xs={12} sx={{ width: { sm: '75%', md: '60%' } }} pt={1}>
						<ScanOrEnterBarcodeForm
							enableAutoEnter={
								genealogyRequired && partNumberScanningRequired ? false : true
							}
							inputRef={inputRef}
							onSubmit={onSerialNumberSubmit}
						/>
					</Grid>
				</Grid>
			);
	};

	useEffect(() => {
		if (!isPopupOpen && inputRef.current) inputRef.current.focus();
	}, [isPopupOpen]);

	useEffect(() => {
		tableRows?.filter((item) => {
			if (item?.quantity === item?.scanJobResults?.length) {
				return setAllScanned(true);
			} else {
				return setAllScanned(false);
			}
		});
	}, [allSacnned, tableRows]);

	// SCAN_ATTRIBUTE: fetch part-attribute by serial number (GET /station/part-attribute/{serialNumber})
	const serialNumber =
		receivePart?.serialNumber ||
		partValidation?.serialNumber ||
		currentLineItem?.serialNumber;

	useEffect(() => {
		if (!serialNumber) return;
		const onPartAttributeSuccess = (data) => {
			const attributes =
				data.attributes && Array.isArray(data.attributes)
					? data.attributes
					: data.scanAttributeJobDetails || [];
			if (!attributes.length) {
				setNoAttributeConfigured(true);
			}
			setAttributeData({
				asn: data.asn || data.sequenceNumber,
				serialNumber: data.serialNumber,
				attributes: attributes.map((a, idx) => ({ ...a, id: a.id ?? `attr-${a.attributeId}-${idx}` })),
			});
		};
		const onPartAttributeError = (error) => {
			// console.log('operations value:', operations);
			// console.log('type:', typeof operations);
			// console.log('is array:', Array.isArray(operations)); 
			const isScanAttributeOnly = operations?.includes('SCAN_ATTRIBUTE') &&
				!operations?.includes('PART_VALIDATION');

			// console.log('operations:', operations);
			// console.log('isScanAttributeOnly:', isScanAttributeOnly);

			if (isScanAttributeOnly) return;

			getPartValidationDetailsForSerialNumber(
				(data) => {
					if (!data.scanJobDetails?.length) {
						setNoPartFamilyConfigured(true);
					} else {
						const nonScannedPartFamilyIndex = data.scanJobDetails.findIndex(
							(part) => part.scanJobResults.length !== part.quantity,
						);
						if (nonScannedPartFamilyIndex === -1)
							setCurrentPartNumber(data.scanJobDetails.length - 1);
						else setCurrentPartNumber(nonScannedPartFamilyIndex);
					}
				},
				(err) => {
					updatePartValidation({});
					showMessageOverlay({
						contextText: SCAN_ATTRIBUTE_ERROR.ERROR_CONTEXT_TEXT + 'Scan Attribute',
						info: err?.response?.data?.message ?? error?.response?.data?.message,
						error: true,
					});
				},
				serialNumber,
			);
		};
		getScanAttributeDetailsForSerialNumber(onPartAttributeSuccess, onPartAttributeError, serialNumber);
	}, [serialNumber]);

	const redirectToHomeScreen = () =>
		redirect(null, {
			operation: OPERATIONS.RECEIVE_PART,
			redirectUrl: REDIRECT_URLS[OPERATIONS.RECEIVE_PART],
		});

	// SCAN_ATTRIBUTE: submit scanned value for selected attribute (POST /station/part-attribute/{asn}/add)
	const onAttributeScanSubmit = (scannedValue, resetBarcodeValue) => {
		if (!attributeData?.asn) return;
		const selectedRow = attributeData.attributes.find(
			(r) => r.id === selectedAttributeRowId,
		);
		const attributeId = selectedRow?.attributeId ?? attributeData.attributes[0]?.attributeId;
		if (attributeId == null) return;
		const closeMessageOverlay = showMessageOverlay({
			contextText: 'Scanning attribute.',
			loading: true,
		});
		scannedAttributeAdd(
			attributeData.asn,
			{ attributeId, scannedValue },
			(data) => {
				const attributes =
					(data.attributes && data.attributes.map((a, idx) => ({ ...a, id: a.id ?? `attr-${a.attributeId}-${idx}` }))) ||
					(data.scanAttributeJobDetails || []).map((a, idx) => ({ ...a, id: a.id ?? `attr-${a.attributeId}-${idx}` }));
				setAttributeData((prev) => (prev ? { ...prev, attributes } : null));
				closeMessageOverlay();
				setAttributeScanSuccessMessage('Attribute scanned successfully');
				setTimeout(() => setAttributeScanSuccessMessage(''), 3000);
				resetBarcodeValue();
			},
			(error) => {
				closeMessageOverlay();
				showMessageOverlay({
					contextText: SCAN_ATTRIBUTE_ERROR.ERROR_CONTEXT_TEXT + 'Scan Attribute',
					info: error?.response?.data?.message,
					error: true,
				});
				resetBarcodeValue();
			},
		);
	};

	const attributeRows = attributeData?.attributes ?? [];
	const attributeScannedCount = attributeRows.filter(
		(r) => r.validatedAt || (r.scannedValue != null && r.scannedValue !== ''),
	).length;
	const allAttributesScanned = attributeRows.length > 0 && attributeScannedCount === attributeRows.length;

	return (
		<>
			<Box sx={{ pr: 2 }}>
				<StyledTable
					title="Current KSPEC"
					columns={PV_DEFAULT_COLUMNS}
					rows={pvData}
					elevated
					virtualized={false}
				/>
			</Box>

			{/* SCAN_ATTRIBUTE: part-attribute table and scan flow */}
			{attributeData != null ? (
				<Box sx={classNames.tableContentContainer}>
					{noAttributeConfigured ? (
						<Grid container paddingX={3} paddingY={5} flex={1} alignItems="end">
							<Grid item container alignItems="center" justifyContent="space-between" columnSpacing={2}>
								<Grid item>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
										<CheckIcon color="primary" sx={{ fontSize: { lg: 34 } }} />
										<Typography variant="h4" color="primary" fontWeight={500}>
											No attributes configured
										</Typography>
									</Box>
								</Grid>
								<Grid item display="flex" gap={2}>
									<MarkComplete
										handleButtonClick={() => {
											markComplete(
												() => { updateScanAttribute({}); redirect(() => handleNext()); },
												(error) => { showMessageOverlay({ contextText: ERROR_MESSAGE.MARK_COMPLETE_ERROR_MESSAGE, info: error?.response?.data?.message, error: true }); },
												attributeData.asn,
											);
										}}
									/>
								</Grid>
							</Grid>
						</Grid>
					) : (
						<>
							<Box sx={{ paddingX: 3, paddingTop: 1 }}>
								<Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
									<TableActionsBar
										leftContent={
											<ProgressHeader
												current={attributeScannedCount}
												total={attributeRows.length}
												label="Scan attribute"
											/>
										}
										showDefactive={
											!!(
												receivePart?.serialNumber ||
												partValidation?.serialNumber
											)
										}
										onDefectClick={() => setIsDefectModalOpen(true)}
										onViewReportClick={openReportModal}
										showColumns
										showFilter
										showViewReport
										columns={SCAN_ATTRIBUTE_COLUMNS}
										defaultColumns={[...SCAN_ATTRIBUTE_COLUMNS]}
										rows={attributeRows}
										onFilterChange={(filters) => { }}
										onColumnChange={(cols) => { }}
									/>
								</Grid>

								{/* Table hamesha visible */}
								<Grid container paddingY={1} alignItems="flex-start" justifyContent="flex-start">
									<Grid item sx={{ width: '100%' }}>
										<StyledTable
											columns={SCAN_ATTRIBUTE_COLUMNS}
											rows={attributeRows}
											showCheckBox
											selectedRows={selectedAttributeRowId != null ? [selectedAttributeRowId] : []}
											onSelectionChange={(ids) => {
												const newId = ids.find((id) => id !== selectedAttributeRowId);
												setSelectedAttributeRowId(newId ?? null);
											}}
											elevated
											sx={{ flex: 1, minHeight: 200 }}
										/>
									</Grid>
								</Grid>

								{/* Neeche: scan input ya completed */}
								<Grid container paddingX={2} paddingY={1} alignItems="center" justifyContent="space-between">
									{allAttributesScanned ? (
										<>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
												<CheckIcon color="primary" sx={{ fontSize: { lg: 34 } }} />
												<Typography variant="h4" color="primary" fontWeight={500}>
													Scan Attribute Completed
												</Typography>
											</Box>
											<MarkComplete
												handleButtonClick={() => {
													markComplete(
														() => { updateScanAttribute({}); redirect(() => handleNext()); },
														(error) => { showMessageOverlay({ contextText: ERROR_MESSAGE.MARK_COMPLETE_ERROR_MESSAGE, info: error?.response?.data?.message, error: true }); },
														attributeData.asn,
													);
												}}
											/>
										</>
									) : attributeScanSuccessMessage ? (
										<Box sx={{ display: 'flex', alignItems: 'center' }}>
											<CheckIcon color="primary" sx={{ fontSize: 34 }} />
											<Typography variant="h4" color="primary" fontWeight={400} paddingLeft={1}>
												{attributeScanSuccessMessage}
											</Typography>
										</Box>
									) : (
										<Grid item sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 2 }}>
											<Typography variant="h3" sx={{ color: '#27C8F7' }}>
												SCAN ATTRIBUTE
											</Typography>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
												<Box sx={{ height: { xs: 35, md: 40, lg: 60 }, width: { xs: 75, md: 85, lg: 130 } }}>
													<img
														src={themeMode === DARK_MODE ? darkBarcode : lightBarcode}
														alt=""
														style={{ height: '100%', width: '120%', objectFit: 'contain' }}
													/>
												</Box>
												<ScanOrEnterBarcodeForm
													enableAutoEnter
													inputRef={inputRef}
													onSubmit={onAttributeScanSubmit}
													placeholder="Scan attribute"
												/>
											</Box>
										</Grid>
									)}
								</Grid>
							</Box>
						</>
					)}
				</Box>
			) : noPartFamilyConfigured ? (
				<Box sx={classNames.tableContentContainer}>
					<Grid container paddingX={3} paddingY={5} flex={1} alignItems="end">
						<Grid
							item
							container
							alignItems="center"
							justifyContent="space-between"
							columnSpacing={2}
						>
							<Grid item>
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
									<CheckIcon
										color="primary"
										sx={{
											fontSize: {
												lg: 34,
											},
										}}
									/>
									<Typography variant="h4" color="primary" fontWeight={500}>
										Part Validation Completed
									</Typography>
								</Box>
							</Grid>

							<Grid item display="flex" gap={2}>
								{!isMobileStation && (
									<>
										<TakeOut
											redirectToNextScreen={redirectToHomeScreen}
											partDetails={partValidation}
										/>
										<MoveToMr partDetails={partValidation} />
									</>
								)}

								<MarkComplete
									handleButtonClick={() => {
										markComplete(
											() => {
												updatePartValidation({});
												redirect(() => handleNext());
											},
											(error) => {
												showMessageOverlay({
													contextText:
														ERROR_MESSAGE.MARK_COMPLETE_ERROR_MESSAGE,
													info: error?.response?.data?.message,
													error: true,
												});
											},
											partValidation.sequenceNumber,
										);
									}}
									onNextOperation={() => redirect(() => handleNext())}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			) : (
				<Box sx={classNames.tableContentContainer}>
					<Box>
						<Grid
							sx={{
								display: 'flex',
								justifyContent: 'center', // horizontal centering
								alignItems: 'center', // vertical centering/ or fixed height so vertical centering works
								width: '100%', // optional, for full width
							}}
						>
							<TableActionsBar
								leftContent={
									<ProgressHeader
										current={3}
										total={5}
										label={'Part Validation'}
									/>
									// <GenealogyChip
									// 	label="Genealogy Success"
									// 	value={5}
									// 	success={true}
									// />
								}
								showDefactive={
									!!(
										receivePart?.serialNumber ||
										partValidation?.serialNumber
									)
								}
								onDefectClick={() => setIsDefectModalOpen(true)}
								onExceptionClick={() => console.log('Exception')}
								onTakeOutClick={openTakeOutModal}
								onViewReportClick={openReportModal}
								showTakeOut={false}
								showColumns={true}
								showFilter={true}
								showViewReport={true}
								showExport={false}
								columns={TEXT_COLUMNS}
								rows={scanJobDetails}
								onFilter={(filteredRows) => setDisplayedRows(filteredRows)}
								onColumnChange={(columns) => setTextColumns(columns)}
								defaultColumns={[...TEXT_COLUMNS]}
							/>
						</Grid>
						<Grid
							container
							// paddingX={2}
							paddingY={1}
							alignItems="flex-start"
							justifyContent="flex-start"
						>
							<Grid
								display="flex"
								justifyContent="flex-start"
								alignItems="stretch"
							>
								<Grid
									item
									sx={{
										width: '68%',
										display: 'flex',
										flexDirection: 'column',
										height: 330,
									}}
									paddingLeft={0}
								>
									<StyledTable
										columns={TEXT_COLUMNS}
										rows={displayedRows}
										showCheckBox
										elevated
										selectedRows={selectedPvRows}
										onSelectionChange={handleSelectionChange}
										paginated={true}
										sx={{ flex: 1 }}
										setSkippart={setSkippart}
									/>
								</Grid>

								<Grid
									item
									sx={{
										width: '35%',
										margin: '0px 12px',
										display: 'flex',
										flexDirection: 'column',
										height: 330,
									}}
								>
									{/* Torque Table */}
									<StyledTable
										columns={columns}
										rows={rows}
										elevated
										paginated={true}
										sx={{ flex: 1 }}
										virtualized={true}
									/>
								</Grid>
							</Grid>

							<Grid item paddingLeft={4} display="flex" gap={2}>
								{!isMobileStation && (
									<>
										<TakeOut
											partDetails={partValidation}
											redirectToNextScreen={redirectToHomeScreen}
											btnStyles={{
												fontSize: pxToRem(15),
												...responsiveFontSizes({ sm: 15, md: 18, lg: 26 }),
												padding: {
													xs: '0.3rem 0.7rem',
													lg: '1rem 1.7rem',
												},
											}}
										/>
										<MoveToMr
											partDetails={partValidation}
											btnStyles={{
												fontSize: pxToRem(15),
												...responsiveFontSizes({ sm: 15, md: 18, lg: 26 }),
												padding: {
													xs: '0.3rem 0.7rem',
													lg: '1rem 1.7rem',
												},
											}}
										/>
									</>
								)}
							</Grid>
						</Grid>
					</Box>

					{modeType === 'Manual Mode' ? (
						<BasicTable
							listId="genealogy-page"
							rows={tableRows || []}
							columns={[...PVnG_DEFAULT_COLUMNS]}
							defaultColumns={[...PVnG_DEFAULT_COLUMNS]}
							showCheckBox
							tableStyles={{
								paper: classNames.paper,
								tableContainer: classNames.tableContentContainer,
							}}
						>
							{(selectedRows) => (
								<>
									<Divider />
									<Grid
										container
										item
										justifyContent="space-between"
										alignItems="bottom"
										paddingX={3}
										paddingBottom={2}
									>
										<Grid xs container>
											<UpdatePartValidationGenealogy
												themeMode={themeMode}
												selectedRows={selectedRows}
												setAllScanned={setAllScanned}
												// revalidatePart={revalidatePart}
												validatePart={validatePart}
												tableRows={tableRows}
												setTableRows={setTableRows}
												partValidation={partValidation}
											/>
										</Grid>
									</Grid>
								</>
							)}
						</BasicTable>
					) : (
						<>
							{/* <Grid container padding={2} flexGrow={1}>
								<Box
									sx={{ position: 'relative', height: '100%', width: '100%' }}
								>
									<Grid
										container
										sx={{
											position: 'absolute',
											left: 0,
											right: 0,
											top: 0,
											bottom: 0,
										}}
										justifyContent="flex-start"
										alignItems="flex-start"
										flexWrap="nowrap"
									></Grid>
								</Box>
							</Grid> */}
							<Grid container paddingX={2} paddingY={1} alignItems="flex-end">
								{/* Skip Button / Success Message */}
								<Grid item>
									<SkipPart
										skippart={skippart}
										hoverMessage="Please select the quantity in sequential manner"
										successCallback={partSkipSuccessCallback}
										errorCallback={partSkipErrorCallback}
									/>
									{/* {!successMessage ? (
                                        <SkipPart
                                            skippart={skippart}
                                            hoverMessage="Please select the quantity in sequential manner"
                                            successCallback={partSkipSuccessCallback}
                                            errorCallback={partSkipErrorCallback}

                                        />
                                    ) : (
                                        <Grid container alignItems="center">
                                            <CheckIcon color="primary" sx={{ fontSize: 34 }} />
                                            <Typography
                                                variant="h4"
                                                color="primary"
                                                fontWeight={400}
                                                paddingLeft={1}
                                            >
                                                {successMessage}
                                            </Typography>
                                        </Grid>
                                    )} */}
								</Grid>

								{/* Fixed space */}
								{!successMessage && (
									<Grid item sx={{ marginLeft: '18%', flexShrink: 0 }}>
										{renderInputFields()}
									</Grid>
								)}
								{allSacnned && (
									<Grid container paddingX={3} paddingY={2} alignItems="center" justifyContent="space-between">
										<Grid item>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
												<CheckIcon color="primary" sx={{ fontSize: { lg: 34 } }} />
												<Typography variant="h4" color="primary" fontWeight={500}>
													Part Validation Completed
												</Typography>
											</Box>
										</Grid>
										<Grid item display="flex" gap={2}>
											{!isMobileStation && (
												<>
													<TakeOut
														redirectToNextScreen={redirectToHomeScreen}
														partDetails={partValidation}
													/>
													<MoveToMr partDetails={partValidation} />
												</>
											)}
											<MarkComplete
												handleButtonClick={() => {
													markComplete(
														() => {
															updatePartValidation({});
															redirect(() => handleNext());
														},
														(error) => {
															showMessageOverlay({
																contextText: ERROR_MESSAGE.MARK_COMPLETE_ERROR_MESSAGE,
																info: error?.response?.data?.message,
																error: true,
															});
														},
														partValidation.sequenceNumber,
													);
												}}
											/>
										</Grid>
									</Grid>
								)}
							</Grid>
						</>
					)}
				</Box>
			)}
			<AllPartsModal
				open={isDetailsModalOpen}
				handleClose={closeDetailsModal}
				rows={[partValidation]}
				columns={[...PV_DEFAULT_COLUMNS]}
				defaultColumns={[...PV_DEFAULT_COLUMNS]}
				title="Current KSPEC"
				subtitle="Key Attributes"
				tableStyles={{ paper: classNames.paper }}
				scannableParts={scanJobDetails}
			/>
			<RescanModal
				open={isReportModalOpen}
				handleClose={closeReportModal}
				rows={[partValidation]}
				columns={[...PV_DEFAULT_COLUMNS]}
				defaultColumns={[...PV_DEFAULT_COLUMNS]}
				title="VALIDATION REPORT"
				subtitle="Key Attributes"
				tableStyles={{ paper: classNames.paper }}
				scannableParts={scanJobDetails}
			/>
			<ReasonAndRemarkModal open={isTakeOutModalOpen} handleClose={closeTakeOutModal} />
			<DefectModal
				open={isDefectModalOpen}
				handleClose={() => setIsDefectModalOpen(false)}
				partDetailsRow={pvData}
				partDetails={{
					serialNumber:
						receivePart?.serialNumber || partValidation?.serialNumber,
					sequenceNumber: partValidation?.sequenceNumber,
				}}
			/>
		</>
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(ProcessValidationStages);
